module.exports = __webpack_public_path__ + "static/img/imgPay.ff0e106.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imgPay.png
// module id = LFuk
// module chunks = 18